import classnames from "classnames";
import { Button } from "neetoui";
import PropTypes from "prop-types";

import "./button-group.scss";

const ButtonGroup = ({ buttons, size = "medium" }) => (
  <div className="neeto-molecules-button-group">
    {buttons.map(({ key, isActive, ...buttonProps }) => (
      <Button
        {...{ size }}
        key={key}
        style="tertiary"
        className={classnames({
          "neeto-molecules-button-group__btn--active": isActive,
        })}
        {...buttonProps}
      />
    ))}
  </div>
);

ButtonGroup.propTypes = {
  /*
   * Array of buttons to be rendered in the group. Each button should have a key, icon, isActive and onClick function.
   */
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
      isActive: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
  /*
   * Size of the buttons in the group.
   */
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

export default ButtonGroup;
